<template>
  <div style="background: #fff; height: 100%">
    <el-container>
      <el-header>
        <div class="handlePanel">
          <el-button
            type="primary"
            v-if="btnAuthorize.modifyBtn.btnEnable"
            @click="changeAllMsgState"
            icon="el-icon-setting"
            >置为已读</el-button
          >
          <el-button
            type="primary"
            v-if="btnAuthorize.delBtn.btnEnable"
            @click="clearAllMsg"
            icon="el-icon-setting"
            >删除消息</el-button
          >
        </div>
      </el-header>
      <el-main ref="main">
        <el-table
          class="ownerTable"
          :data="tableData"
          height="100%"
          size="mini"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in formTitles"
            :key="index"
            :prop="item.class"
            :label="item.labelName"
            :sortable="item.sortable"
            :width="item.width"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button @click="NewsDetail(scope.row)" type="text" size="small"
                >查看</el-button
              >
              <el-button
                v-if="scope.row.isCheck == 0"
                @click="changeMsgState(scope.row)"
                type="text"
                size="small"
                >置为已读</el-button
              >
            </template>
            <!-- <template slot-scope="scope">
              <span
                :style="scope.row.isRead == 0 ? 'color:#079DBD;font-size:12px;cursor:pointer;' : 'color:#333333;font-size:12px;'"
                @click="changeMsgState(scope.$index, scope.row)"
              >{{scope.row.isCheck == 0 ? '置为已读' : '已读'}}</span>
            </template> -->
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div style="display: flex; justify-content: space-between">
          <span
            style="
              color: #666666;
              font-size: 14px;
              line-height: 32px;
              margin-top: 16px;
            "
            >显示{{
              totalCount > 0
                ? (currentPage - 1) * pageSize +
                  1 +
                  "-" +
                  (currentPage * pageSize > totalCount
                    ? totalCount
                    : currentPage * pageSize)
                : "0"
            }}，共{{ totalCount }}条记录</span
          >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import {
  getLatestFileList,
  readDocumentMsg,
  deleteDocumentService,
} from "../../services/sysSettingService";
import Constants from "@/utils/consts.js";

import { getRouteIdByType } from "@/page/approveComponents/approve";

export default {
  name: "latestNews",
  props: {
    menuCode: {
      type: String,
    },
  },

  data() {
    return {
      formInline: {
        user: "",
      },
      formTitles: [
        // { class: "id", labelName: "序号", sortable: false },
        { class: "title", labelName: "公文标题", sortable: false },
        // { class: "actName", labelName: "内容", sortable: false },
        { class: "createTime", labelName: "接收时间", sortable: false,width:'200px' },
        { class: "checkStatusDisplayName", labelName: "状态", sortable: false,width:'160px' },
      ],
      tableData: [],
      selectItems: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      // settingBtnEnable: false,
      showHouseBind: false,
      showHouseBindTitle: "",
      showHouseRoomData: {},
      btnAuthorize: {
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
      },
    };
  },
  mounted() {},
  methods: {
    onActive(menuCode) {
      this.currentPage = 1;
      this.getMsgList();
      this.$getRoleBtns(menuCode, this.btnAuthorize);
    },
    getMsgList() {
      let param = {
        // userId: sessionStorage.getItem("userCode"),
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
      };

      getLatestFileList(param)
        .then((res) => {
          if (res.code == 10000000) {
            // for (let index = 0; index < res.data.list.length; index++) {
            //   var element = res.data.list[index];
            //   if (element.messageBehavior == "700001")
            //     element.messageBehaviorStr = "绑定房产";
            //   let obj = JSON.parse(element.sendMessage);
            //   let msg =
            //     "业主" +
            //     obj.ownerName +
            //     "(" +
            //     obj.phone +
            //     ")" +
            //     "申请绑定" +
            //     obj.showName +
            //     ",请尽快处理";
            //   element.originMessage = element.sendMessage;
            //   element.sendMessage = msg;
            //   console.log(obj);
            // }
            this.totalCount = res.total;
            this.tableData = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((err) => {});
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getMsgList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getMsgList();
    },
    //更改选择项
    handleSelectionChange(val) {
      this.selectItems = val;
    },
    changeMsgState(row) {
      if (row.isCheck != 0) {
        return;
      }
      readDocumentMsg({ ids: row.id })
        .then((res) => {
          // this.$alert(res.msg, "提示", {
          //   confirmButtonText: "确定"
          // });
          this.getMsgList();
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },

    //跳转详情
    NewsDetail(row) {
      // let memberData = {};
      // memberData.editFlag = false; //查看标志为1
      // memberData.id = row.resourceId; //选中行
      // memberData.addFlag = 0; //新增标志为1
      if (row.isCheck == 0) {
        readDocumentMsg({ ids: row.id })
          .then((res) => {
            // this.$alert(res.msg, "提示", {
            //   confirmButtonText: "确定"
            // });
            this.getMsgList();
          })
          .catch((error) => {
            // this.$message.error("系统异常");
          });
      }
      let routeId = "generalOfficeDetails";
      let type=1
      switch (row.resourcePathType) {
        case "processing_details": //收文查阅详情
          routeId = "processingDetails";
          break;
        case "common_check_details": //收文查阅详情
          routeId = "processingDetails";
           type=2
          break;
        case "general_office_details": //综合办发文
          routeId = "generalOfficeDetails";
          break;
        case "general_office_details": //我的发文(其他)
          routeId = "generalOfficeDetails";
          break;
        case "document_manage_details": //我的发文(综合办)
          routeId = "documentManageDetails";
          break;
        default:
          // this.Contractform.tabIndex = "0";
          break;
      }
      this.bus.$emit("navMenuChange", {
        routeId: routeId,
        routeParam: {
          approveFlag: "documentMessage",
          id: row.resourceId,
          approveType:row.businessType,
          type:type
        },
      });
    },
    //置为已读按钮
    changeAllMsgState() {
      //点击置为已读按钮
      if (this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let ids = [];
      for (let index = 0; index < this.selectItems.length; index++) {
        const element = this.selectItems[index];
        ids.push(element.id);
      }
      let groupIdSet = ids.join(",");
      readDocumentMsg({ ids: groupIdSet })
        .then((res) => {
          this.$alert(res.msg, "提示", {
            confirmButtonText: "确定",
          });
          this.getMsgList();
        })
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    //置为已读
    changeState() {
      //do something
    },
    //清空消息中心 20230312
    clearAllMsg() {
      //点击删除按钮并确认删除
      if (this.selectItems.length == 0) {
        this.$alert(Constants.No_Select_Tip, "提示", {
          confirmButtonText: "确定",
        });
        return;
      }

      this.$confirm("确定要删除消息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        let ids = [];
        for (let index = 0; index < this.selectItems.length; index++) {
          const element = this.selectItems[index];
          ids.push(element.id);
        }
        let groupIdSet = ids.join(",");
        deleteDocumentService({
          ids: groupIdSet,
        })
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              this.$alert(Constants.Ok_Msg, "提示");
              this.getMsgList();
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    closeDialogAction() {
      this.showHouseBind = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.operateView {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
/deep/.el-table__header {
  background: red !important;
}
</style>
